<template>
  <div class="new-record">
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
            <v-card-title class="title grey lighten-2" primary-title>Add New Facebook Account</v-card-title>

            <v-card-text class="pt-3">
              
              <v-form ref="form" v-model="valid">

                <v-text-field v-model="profile" :rules="nameRules" label="Account Profile (*)" required></v-text-field>

                <v-text-field v-model="email" :rules="emailRules" label="Login E-mail (*)" required></v-text-field>

                <v-text-field v-model="password" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :rules="[rules.required]"
                    :type="show ? 'text' : 'password'"
                    label="Password (*)"
                    @click:append="show = !show"
                    required
                ></v-text-field>

                <v-text-field v-model="usefor" :rules="nameRules" label="Use For (*)" required></v-text-field>

                <v-text-field v-model="phone" label="Phone Number (optional)" required></v-text-field>

                <!-- <v-text-field v-model="status" label="Status (optional)" required></v-text-field> -->
                <v-select :items="items" v-model="status" label="Status"></v-select>

                <v-textarea v-model="remark" outlined label="Remark (Optional)"></v-textarea>

              </v-form>

            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
                <v-btn dark @click="$emit('dialogHide')">Cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue-grey white--text" :loading="$store.state.snackSuccess" :disabled="!valid" @click="saveRecord">Create</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

  </div>
</template>

<script>

export default {
  props: [ 'dialog', 'Type', 'counter' ],

  data: () => ({
    
      nameRules: [
        v => !!v || 'Name is required',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      rules: {
          required: value => !!value || 'Required.'
      },
      valid: true,
      show: false,
      profile: '',
      email: '',
      password: '',
      usefor: '',
      phone: '',
      status: false,
      items: [
          { text: 'Active', value: false },
          { text: 'Disabled', value: true }
      ],
      remark: ''
  }),

  methods: {

    saveRecord() {

      this.$store.dispatch('storeFacebook', {
        profile: this.profile,
        email: this.email,
        password: this.password,
        usefor: this.usefor,
        phone: this.phone,
        status: this.status,
        remark: this.remark,
        counter: parseInt(this.counter) 
      })
      .then(() => { this.$emit('dialogHide'); });

    }

  },

}
</script>

<style>

</style>